import { render, staticRenderFns } from "./RepeatTypeCard.vue?vue&type=template&id=8361aff4"
import script from "./RepeatTypeCard.vue?vue&type=script&lang=js"
export * from "./RepeatTypeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports